/**
 *
 * @param {number} itemId - id of item where package subdrawer should be rendered
 */
export const toggleOpenPackageSubDrawer = ({ commit, state }, productId: number) => {
  const openPackageSubDrawerId = state.openPackageSubDrawerId !== productId ? productId : null;

  commit('UPDATE_OPEN_PACKAGE_SUB_DRAWER', openPackageSubDrawerId);
};

/**
 * Update isUploadingTags to true/false
 */
export const toggleIsUploadingTags = ({ commit, state }) => {
  commit('UPDATE_IS_UPLOADING_TAGS', !state.isUploadingTags);
};
